<template>
<div>
    <!-- Dropdown menu on small screens -->
    <div class="sm:hidden">
      <label for="selected-tab" class="sr-only">Select a tab</label>
      <select id="selected-tab" name="selected-tab" class="form-input" v-model="activeTab">
        <option value="present" selected>Present</option>
      </select>
    </div>
    <!-- Tabs at small breakpoint and up -->
    <div class="hidden sm:block">
      <nav class="-mb-px border-b dark:border-gray-700">
        <div class="flex justify-between max-w-screen-xl w-full mx-auto">
          <div class="flex space-x-8">
            <!-- Current: "border-blue-500 text-blue-600", Default: "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300" -->
            <button data-tippy-content="The main tab for your session" @click="activeTab = 'present'"
                    class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 whitespace-nowrap pb-2 px-1 border-b-2 font-medium text-sm"
                    :class="{'border-blue-500 text-blue-600 dark:text-blue-300' : activeTab == 'present'}" aria-current="page">
		          <!-- Slidwshow icon -->
		          <svg class="h-4 w-4 mr-1 text-gray-400 fill-current inline" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 13V12M12 13V10M16 13V8M8 21L12 17L16 21M3 4H21M4 4H20V16C20 16.5523 19.5523 17 19 17H5C4.44772 17 4 16.5523 4 16V4Z"/></svg>
              Present
            </button>

            <button data-tippy-content="Edit presenter" @click="activeTab = 'editor'"
                    class="border-transparent text-gray-500 hover:text-gray-700 dark:hover:text-gray-100 hover:border-gray-300 whitespace-nowrap pb-2 px-1 border-b-2 font-medium text-sm"
                    :class="{'border-blue-500 text-blue-600 dark:text-blue-300' : activeTab == 'editor'}">
              <svg class="h-4 w-4 mr-1 text-gray-400 fill-current inline" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path fill-rule="evenodd"
                      d="M12 4C11.4477 4 11 4.44772 11 5C11 6.69226 8.95399 7.53974 7.75738 6.34314C7.36686 5.95261 6.73369 5.95261 6.34317 6.34314C5.95265 6.73366 5.95265 7.36683 6.34317 7.75735C7.53982 8.954 6.69223 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13C6.69236 13 7.53964 15.0461 6.34311 16.2426C5.95258 16.6332 5.95258 17.2663 6.34311 17.6569C6.73363 18.0474 7.3668 18.0474 7.75732 17.6569C8.9539 16.4603 11 17.3077 11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19C13 17.3077 15.046 16.4602 16.2427 17.6568C16.6332 18.0474 17.2664 18.0474 17.6569 17.6568C18.0474 17.2663 18.0474 16.6332 17.6569 16.2426C16.4603 15.0461 17.3077 13 19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C17.3078 11 16.4601 8.95405 17.6568 7.75737C18.0473 7.36684 18.0473 6.73368 17.6568 6.34315C17.2663 5.95263 16.6331 5.95263 16.2426 6.34315C15.046 7.53979 13 6.69219 13 5C13 4.44772 12.5523 4 12 4ZM9.00816 4.77703C9.12224 3.2243 10.4181 2 12 2C13.5819 2 14.8778 3.2243 14.9918 4.77703C16.1704 3.75977 17.9525 3.8104 19.071 4.92894C20.1896 6.04748 20.2402 7.82955 19.2229 9.00816C20.7757 9.12221 22 10.4181 22 12C22 13.5819 20.7757 14.8778 19.223 14.9918C20.2403 16.1704 20.1896 17.9525 19.0711 19.0711C17.9525 20.1896 16.1705 20.2402 14.9918 19.2229C14.8778 20.7757 13.5819 22 12 22C10.4181 22 9.12221 20.7757 9.00816 19.2229C7.82955 20.2402 6.04745 20.1896 4.92889 19.0711C3.81034 17.9525 3.75972 16.1704 4.77702 14.9918C3.2243 14.8778 2 13.5819 2 12C2 10.4181 3.22433 9.12221 4.77709 9.00816C3.75978 7.82955 3.81041 6.04747 4.92896 4.92892C6.0475 3.81038 7.82955 3.75975 9.00816 4.77703Z"
                      clip-rule="evenodd"/>
                <path fill-rule="evenodd"
                      d="M12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10ZM9.17157 9.17157C9.92172 8.42143 10.9391 8 12 8C13.0609 8 14.0783 8.42143 14.8284 9.17157C15.5786 9.92172 16 10.9391 16 12C16 13.0609 15.5786 14.0783 14.8284 14.8284C14.0783 15.5786 13.0609 16 12 16C10.9391 16 9.92172 15.5786 9.17157 14.8284C8.42143 14.0783 8 13.0609 8 12C8 10.9391 8.42143 9.92172 9.17157 9.17157Z"
                      clip-rule="evenodd"/>
              </svg>
              Edit presentation
            </button>
          </div>
          <div class="mb-2">
            <div v-if="!roomActivated || timeRemaining <= 300000" class="space-x-2">
              <a href="/" class="underline"  data-turbolinks="false">Home</a>
              <button class="btn btn-primary text-sm px-8 pulse-halo" @click="showActivationModal = true">Activate
              </button>
            </div>
            <div class="flex space-x-2" v-if="roomActivated">
              <div>
                Time remaining:
              </div>
              <div class="font-mono">
                {{
                `${parseInt(timeRemaining / 1000 / 60 / 60)}`.padStart(2, '0')
                }}:{{
                `${parseInt(timeRemaining / 1000 / 60 % 60)}`.padStart(2, '0')
                }}:{{ `${parseInt(timeRemaining / 1000 % 60)}`.padStart(2, '0') }}
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
    <div class="flex">
  <!-- Main flex -->
  <main class="w-full grid grid-cols-2 pt-2 lg:grid-cols-12 gap-4 px-4 lg:px-0 pb-32" v-show="activeTab == 'present'">
    <!-- Viewport -->
    <div class="lg:col-span-2 order-6 lg:order-1 flex flex-col space-y-2 h-64 xl:h-128" style="height: 48rem;">
        <slides-manager class="flex-grow" ref="slides" :slides="slides" v-bind:current-slide-index.sync="currentSlideIndex"> </slides-manager>
      </div>
    <div class="lg:col-span-8 2xl:col-span-8 col-span-2 lg:order-2">
      <presenter-viewport ref="viewport" @create-take-folder="$refs.videoTakeList.showCreateFolderModal = true"
                          @newSlides="onNewSlides"
                          :presentation-id="presentationId"
                          :is-sharing-screen="isSharingScreen"
                          v-bind:current-slide-index.sync="currentSlideIndex"
                          :selected-anim="selectedAnim"
                          :room-activated="true"
                          :roomKey="room.key">
      
      </presenter-viewport>
    </div>
    <!-- Slides -->
    <div class="lg:col-span-2 lg:order-4 space-y-2">
      <select class="flex-shrink-0 form-input" v-model="selectedAnim" @change="onChangeSelect($event)">
        <option v-for="x in animations" :key="x" :value="x">{{x}}</option>
      </select>
        <div v-if="role === 'host'" class="flex-shrink-0">
          <sound-reactions class="w-auto" customClass="grid-cols-3" :show-label="false"></sound-reactions>
        </div>
          <timer></timer>
          <div class="flex flex-wrap space-x-2 justify-between text-gray-600">
            <label for="actPointers">
              Activate pointers
            </label>
            <div class="form-switch" @click="togglePointerActive" id="actPointers" data-id="pointers">
              <input type="checkbox"  :checked="isPointersActive" :disabled="!roomActivated">
              <i></i>
            </div>
          </div>

          <div class="flex flex-wrap space-x-2 justify-between text-gray-600">
            <label for="muteMicrophone">
              Quiet audio
            </label>
            <div class="form-switch" @click="toggleQuietAudio" id="quietAudio" data-id="quietAudio">
              <input type="checkbox" :checked="isQuietAudioActive" :disabled="!roomActivated">
              <i></i>
            </div>
          </div>

          <div class="flex flex-wrap space-x-2 justify-between text-gray-600">
            <label for="toggleCurtain">
              Show curtain
            </label>
            <div class="form-switch" @click="toggleCurtain">
              <input type="checkbox" id="showCurtain" :checked="showCurtain" :disabled="!roomActivated">
              <i></i>
            </div>
          </div>
 <!-- Participants  -->
      <div class="lg:col-span-2 order-6 lg:order-3 flex flex-col space-y-2 h-64 xl:h-64" style="height: 20rem;">
        <div class="">
          <div class="flex justify-between">
            <participant ref="meParticipant" class="slide-in-item"
                         :peer='{ id: "soundMeterMainTower", name: this.name, role: "Host", status: "connected", audio_input: "this is not defined a peer not_defined", latency: 0, upload_speed: -1, download_speed: -1}'
                         :showActions="false"></participant>
          <a rel="nofollow" @click="showParticipantsModal = true"
             class="block text-blue-200 hover:bg-transparent rounded-md hover:text-blue-500 cursor-pointer underline text-right"
             data-e2e="manage_test">
            Manage participants
          </a>
          </div>
        </div>
        <mirror-participant-list ref="participantList" class="flex-grow" style="height: 15rem"></mirror-participant-list>
      </div>
        </div>
    </main> <!-- MainFlex END -->
    <aside class="bg-gray-800 border-2 space-y-2"  v-show="activeTab == 'present'">
      <div class="flex justify-between">
        <button class="h-16 w-16 px-2 py-2 hover:bg-gray-500"
        :class="showMediaFolder ? 'bg-gray-500' : 'bg-gray-700'"
        @click="showMediaFolder = !showMediaFolder;">Media</button>
      </div>
    <div class="fixed right-0 top-36 bg-gray-800 rounded-md text-white z-20 px-2 pt-2 pb-8 w-[52rem]"
       :class="showMediaFolder ? 'h-[36rem]' :''"  v-if="showMediaFolder">
      <!-- Media -->
      <button v-if="showMediaFolder" class="btn btn-secondary absolute top-5 right-5" @click="showMediaFolder = false;">Close</button>
      <media-manager class="dark" :is-host="true"></media-manager>
    </div>
        <div class="flex justify-between">
          <button class="h-16 w-16 px-2 py-2 hover:bg-gray-500"
            :class="showPinboard ? 'bg-gray-500' : 'bg-gray-700'"
           @click="showPinboard = !showPinboard;">Pinboard</button>
        </div>
    <div class="fixed right-0 bg-gray-800 rounded-md text-white z-20 px-2 py-2 w-96" :class="showPinboard ? 'h-full' :''"   v-if="showPinboard">
      <!-- Pinboard -->
      <div style="height: 33rem;">
          <button v-if="showPinboard" class="btn btn-secondary absolute -left-8 -top-8" @click="showPinboard = false;">Close</button>
        <pinboard class="dark" :presentation-id="presentationId" :p-key="room.key" :role="'host'" grid-count="grid-cols-3 gap-3 sm:grid-cols-4 xl:grid-cols-3"></pinboard>
      </div>
    </div>

    </aside>

    <main class="w-full" v-show="activeTab == 'editor'">
      <presentation-editor :presentation-id="presentationId"> </presentation-editor>
    </main>
  </div>
    <!-- Tasks (this shows stuff like connecting to server) -->
    <div class="fixed right-0 bottom-0 px-5 py-5 bg-white shadow-lg border rounded-md status-indicator z-40">
      <div class="tasks"></div>
    </div>
    <modal :showModal="showParticipantsModal" @close="showParticipantsModal = false" classSize="sm:max-w-2xl">
      <manage-participants @close-modal="showParticipantsModal = false"
                           :room="room" :roles="roles"
                           :is-in-trial="false"></manage-participants>
    </modal>
    <!-- Activation modal -->
    <modal :showModal="showActivationModal" @close="showActivationModal = false">
      <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
        <!-- Upload cloud icon -->
        <svg class="h-6 w-6 text-green-600 fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
             viewBox="0 0 24 24">
          <path fill-rule="evenodd"
                d="M11 4C8.79082 4 7 5.79085 7 8C7 8.03242 7.00047 8.06627 7.00131 8.10224C7.01219 8.56727 6.70099 8.97839 6.25047 9.09416C4.95577 9.42685 4 10.6031 4 12C4 13.6569 5.34317 15 7 15H8C8.55228 15 9 15.4477 9 16C9 16.5523 8.55228 17 8 17H7C4.23861 17 2 14.7614 2 12C2 9.93746 3.2482 8.16845 5.02926 7.40373C5.32856 4.36995 7.88746 2 11 2C13.2236 2 15.1629 3.20934 16.199 5.00324C19.4207 5.10823 22 7.75289 22 11C22 14.3137 19.3138 17 16 17C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15C18.2092 15 20 13.2091 20 11C20 8.79085 18.2092 7 16 7C15.8893 7 15.78 7.00447 15.6718 7.01322C15.2449 7.04776 14.8434 6.8066 14.6734 6.4135C14.0584 4.99174 12.6439 4 11 4ZM11.2929 9.29289C11.6834 8.90237 12.3166 8.90237 12.7071 9.29289L14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071C14.3166 13.0976 13.6834 13.0976 13.2929 12.7071L13 12.4142V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V12.4142L10.7071 12.7071C10.3166 13.0976 9.68342 13.0976 9.29289 12.7071C8.90237 12.3166 8.90237 11.6834 9.29289 11.2929L11.2929 9.29289Z"
                clip-rule="evenodd"/>
        </svg>
      </div>
      <div class="mt-3 text-center sm:mt-5">
        <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
          Activate session
        </h3>
        <div class="mt-2">
          <p class="text-sm text-gray-500">
            Please, choose one of the following activations to start your session.
          </p>
        </div>
      </div>
      <div class="mt-3 text-center sm:mt-5" v-if="isInTrial && tokens.length === 0">
        <div class="mt-2">
          <p class="text-sm text-red-500">
            You run out of activations. To buy more activations consider upgrading your account
          </p>
        </div>
      </div>
      <div class="mt-5 space-x-2 text-center">
        <a href="/payment/products/mirror-tokens/purchase" class="btn btn-sm btn-primary"
           v-if="tokens.length == 0 && !isInTrial">Buy Activations</a>
        <button class="btn btn-sm btn-secondary text-sm" @click="activateRoom(t.token_id)" v-for="t in tokens">Activate
          for {{ t.token.duration }}h
        </button>
      </div>
    </modal>
    <modal :showModal="showExpirationModal" @close="showExpirationModal = false">
      <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
        <!-- Upload cloud icon -->
        <svg class="h-6 w-6 text-green-600 fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
             viewBox="0 0 24 24">
          <path fill-rule="evenodd"
                d="M11 4C8.79082 4 7 5.79085 7 8C7 8.03242 7.00047 8.06627 7.00131 8.10224C7.01219 8.56727 6.70099 8.97839 6.25047 9.09416C4.95577 9.42685 4 10.6031 4 12C4 13.6569 5.34317 15 7 15H8C8.55228 15 9 15.4477 9 16C9 16.5523 8.55228 17 8 17H7C4.23861 17 2 14.7614 2 12C2 9.93746 3.2482 8.16845 5.02926 7.40373C5.32856 4.36995 7.88746 2 11 2C13.2236 2 15.1629 3.20934 16.199 5.00324C19.4207 5.10823 22 7.75289 22 11C22 14.3137 19.3138 17 16 17C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15C18.2092 15 20 13.2091 20 11C20 8.79085 18.2092 7 16 7C15.8893 7 15.78 7.00447 15.6718 7.01322C15.2449 7.04776 14.8434 6.8066 14.6734 6.4135C14.0584 4.99174 12.6439 4 11 4ZM11.2929 9.29289C11.6834 8.90237 12.3166 8.90237 12.7071 9.29289L14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071C14.3166 13.0976 13.6834 13.0976 13.2929 12.7071L13 12.4142V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V12.4142L10.7071 12.7071C10.3166 13.0976 9.68342 13.0976 9.29289 12.7071C8.90237 12.3166 8.90237 11.6834 9.29289 11.2929L11.2929 9.29289Z"
                clip-rule="evenodd"/>
        </svg>
      </div>
      <div class="mt-3 text-center sm:mt-5">
        <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline-">
          Session about to expire
        </h3>
        <div class="mt-2">
          <p class="text-sm text-gray-500">
            Your session is about to expire. Consider using another activation to avoid interrupting the session
          </p>
        </div>
      </div>
      <div class="mt-3 text-center sm:mt-5" v-if="isInTrial && tokens.length === 0">
        <div class="mt-2">
          <p class="text-sm text-red-500">
            You run out of activations. To buy more activations consider upgrading your account
          </p>
        </div>
      </div>
      <div class="mt-5 space-x-2 text-center">
        <a href="/payment/products/mirror-tokens/purchase" class="btn btn-sm btn-primary"
           v-if="tokens.length == 0 && !isInTrial">Buy Activations</a>
        <button class="btn btn-sm btn-secondary text-sm" @click="activateRoom(t.token_id)" v-for="t in tokens">Activate
          for {{ t.token.duration }}h
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from "axios";
import {detectBrowser} from 'utils/browser';
import messageBroker from 'general/messageBroker';
import {localNotify} from "utils/notifications";
import commandsManager from 'general/CommandsManager'
import soundMeter from './sound-meter.vue';
import MirrorParticipantList from './mirror/mirror-participant-list.vue'

export default {
  components: { soundMeter, MirrorParticipantList },
  name: "presenter-host",
  props: {
    room: {},
    presentationId: {
      type: Number,
      required: true
    },
    roles: {
      type: Array
    },
    activeUntil: {},
    name: {},
    tokens: {},
    activeUntil: {
      type: Number
    },
    isInTrial: {},
  },
  data() {
    return {
      activeTab: 'present',
      roomActivated: false,

      showParticipantsModal: false,
      showActivationModal: false,
      showExpirationModal: false,
      timeRemaining: false,
      token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      //Slides management
      currentSlideIndex: 0,
      slides: [],
      isPointersActive: false,
      isSharingScreen: false,
      // Animations
      animations: ['No transition', 'fade', 'slide-fade' ],
      selectedAnim: 'No transition',

      isQuietAudioActive: false,
      role: "host",
      showMediaFolder: false,
      showPinboard: false,

      showCurtain: true,
    }
  },
  mounted() {
    var self = this;
    self.roomActivated = self.activeUntil !== 0;
    if (self.roomActivated) {
      $("#endOfSessionButton").removeClass("hidden")
      this.$root.$emit('roomActivated');
    }
    self.startTimer();

    // START WEBRTC
    setupEngine('presenter', 'host', "NAME", window.participant_key, window.room_key)

    // check if browser is compatible
    this.checkBrowser();
    // set the warning message before unload ("You are leaving this site")
    // setBeforeUnload();

    window.role = 'host'
    window.authenticity_token = this.authenticity_token
    window.room = this.room.key
    window.product = 'presenter'
    window.room_key = this.room.key
    window.name = this.name
    window.activeUntil = self.activeUntil


    // Enable participant list connections
    // Taken from startTimer func from mirror-host
    this.$refs.participantList.showActions = true;
    this.$refs.viewport.slidesLoader.loadSlides();
    commandsManager.registerNewCommand('slide_changed', (data) => {
      this.currentSlideIndex = data.args;
    });
    commandsManager.registerNewCommand('animation_changed', ()=>{});
    commandsManager.registerNewCommand('presenter--toggle-curtain', ()=>{});
  },
  watch:{
    activeTab(oldValue, newValue){
      if(this.activeTab == 'present'){
        //reload slides
        if (this.$refs.viewport) {
          vm.$refs.orchestrator.$refs.viewport.slidesLoader.loadSlides()
          .then((slides)=>{
            vm.$refs.orchestrator.$refs.viewport
            this.slides = slides;

            // this is a trick to make the viewport update the slide
            this.currentSlideIndex = 1;
            window.setTimeout(()=>{
            this.currentSlideIndex = 0;;
            })

            manager.peerList.forEach((peer)=>{
              this.sendSlides(peer.public_key);
            })
          });
        }
      }
    },
  },
  methods: {
    onNewSlides(slides){
      this.slides = slides;
      manager.peerList.forEach((peer)=>{
        this.sendSlides(peer.public_key);
      })
    },
    sendSlides(peerId){
      messageBroker.sendCommand('init_presentation', peerId, {peer_key: window.participant_key, slides: this.slides});
      setTimeout(() => {
        messageBroker.sendCommand('presenter--toggle-curtain', peerId, {show: this.showCurtain})
        messageBroker.sendCommand('slide_changed', peerId, this.currentSlideIndex)

        if(this.isPointersActive){
          messageBroker.sendCommand('presenter--pointers_active', peerId);
        } else{
          messageBroker.sendCommand('presenter--pointers_inactive', peerId);
        } 
      }, 3000);
    },
    checkBrowser() {
      if (detectBrowser(window).browser === 'chrome' && detectBrowser(window).version >= 81
          // disabling firefox support
          // || (detectBrowser(window).browser == 'firefox' && detectBrowser(window).version >= 78)
         ) {
        // place only chrome stuff here
      } else {
        $("#browserNotCompatible").removeClass("hidden")
        $("#browserName").html(detectBrowser(window).browser + " " + detectBrowser(window).version)
      }
    },

    startTimer() {
      this.activationTimer = window.setInterval(() => {
        this.timeRemaining = parseInt(this.activeUntil * 1000) - new Date();
        if (this.timeRemaining <= 0) {
          this.$refs.participantList.showActions = false;
          clearInterval(this.activationTimer);
          this.roomActivated = false;
          this.activationTimer = null;
          $("#endOfSessionButton").addClass("hidden")
          //disconnect
        } else {
          if (this.$refs.participantList)
            this.$refs.participantList.showActions = true;
        }
        if (parseInt(this.timeRemaining / 1000) === 300) {
          localNotify('Time is running out');
          this.showExpirationModal = true
        }
      }, 1000)
    },
    activateRoom(token_id) {
      var self = this;
      axios.post('/rooms/activate', {room_id: this.room.id, tk_id: token_id, authenticity_token: this.token}, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }).then(response => {
        this.showExpirationModal = false;
        this.showActivationModal = false;
        this.roomActivated = true;
        if (response.data.activated) {
          this.activeUntil = new Date(response.data.data.active_until).getTime() / 1000;
          window.activeUntil = this.activeUntil
          commandsManager.sendAllCommand('active_until', {activeUntil: parseInt(window.activeUntil * 1000) - new Date()})
          this.$root.$emit('roomActivated')
          $("#endOfSessionButton").removeClass("hidden");
          this.startTimer();
        }
      }).catch(error => {
        alert(error.message)
      })
    },
    togglePointerActive(){
      this.isPointersActive = !this.isPointersActive;
      if(this.isPointersActive){
        commandsManager.sendAllCommand('presenter--pointers_active');
        vm.$refs.orchestrator.$refs.viewport.togglePointers(true);
      }else{
        commandsManager.sendAllCommand('presenter--pointers_inactive');
        vm.$refs.orchestrator.$refs.viewport.togglePointers(false);
      }
    },
    onChangeSelect(event) {
      console.log("gets here ", event.target.value)
      commandsManager.sendAllCommand('animation_changed', { selectedAnim: event.target.value })
    },
    toggleQuietAudio(){
      this.isQuietAudioActive = !this.isQuietAudioActive;
      commandsManager.sendAllCommand('quiet_audio', {active: this.isQuietAudioActive} );
      vm.$refs.orchestrator.$refs.viewport.isQuietAudioActive = this.isQuietAudioActive;
    },
    toggleCurtain(){
      this.showCurtain = !this.showCurtain;
      commandsManager.sendAllCommand('presenter--toggle-curtain', {show: this.showCurtain})
      vm.$refs.orchestrator.$refs.viewport.showCurtain = this.showCurtain;
    }
  }
}
</script>

<style scoped>

</style>
